"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chunkYEZHZTDTjs = require('./chunk-YEZHZTDT.js');

require('./chunk-SSOLMJ6R.js');

require('./chunk-6R5OOOHC.js');

require('./chunk-R4XHR6A7.js');

require('./chunk-OUWZ2PU5.js');

exports.coreColors = _chunkYEZHZTDTjs.a;
exports.proxibidColors = _chunkYEZHZTDTjs.b;
exports.proxibidTheme = _chunkYEZHZTDTjs.d;
exports.themeSettings = _chunkYEZHZTDTjs.c;